import { createRoot } from "react-dom/client";
import msalInstance from "@/utils/msalInstance";

import App from "./App";
import "./i18n";

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(<App msalInstance={msalInstance} />);
